import type { DeploymentResponse } from '@emma/api_client/types';
import { Link } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { type DetailSectionProps, DetailsBox } from '@/components/common/details/DetailsBox';
import { UserNameLink } from '@/components/common/UserNameLink';
import { dateTimeFormat } from '@/utility/date';
import { paths } from '@/utility/global_paths';

type Props = {
  deployment: DeploymentResponse;
  workspaceId: number;
};

export const DeploymentDetails = ({ deployment, workspaceId }: Props) => {
  const deploymentDetailsSections = [
    {
      items: {
        ID: { body: deployment.id },
        'Application ID': {
          body:
            deployment.applicationId == null ? (
              '-'
            ) : (
              <Link
                as={ReactRouterLink}
                p={0}
                to={paths.applicationById(workspaceId, deployment.applicationId)}
              >
                {deployment.applicationId}
              </Link>
            ),
        },
        'Created By': { body: <UserNameLink oid={deployment.createdByOid} /> },
        Created: { body: new Date(deployment.createdAt).toLocaleString(dateTimeFormat.local) },
        Updated: { body: new Date(deployment.updatedAt).toLocaleString(dateTimeFormat.local) },
      },
    },
  ] as DetailSectionProps[];

  return <DetailsBox sections={deploymentDetailsSections} title="Deployment" />;
};
